import { configureStore } from "@reduxjs/toolkit";
import addBookSlice from "./slices/books/addBookSlice";
import bookSelectionSlice from './slices/books/bookSelectionSlice';
import authSlice from "./slices/auth/authenticationSlice";
import usersSlice from "./slices/users/usersSlice";
import featureSlice from "./slices/features/userFeatureSlice";
import startupContentsSlice from "./graphQL/slices/startupContentsSlice";
import ownBooksSlice from "./slices/books/premium/ownBooksSlice";


window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()
export const store = configureStore({
    reducer: {
        auth: authSlice,
        addBooks: addBookSlice,
        bookSelection: bookSelectionSlice,
        users: usersSlice,
        features: featureSlice,
        startupContents: startupContentsSlice,
        ownBooks: ownBooksSlice
    }
});